import React from "react";
import { object } from "prop-types";
import { ThreeColTwelveStories } from "../../../../arrow";

export const ArrowThreeColTwelveStories = ({ collection }) => {
  const config = {
    buttonText: `Read More`,
    showImagePlaceholder: true,
    showSection: false,
    theme: "",
    showReadTime: false,
  };
  return <ThreeColTwelveStories collection={collection} config={config} />;
};

ArrowThreeColTwelveStories.propTypes = {
  collection: object,
};

ArrowThreeColTwelveStories.storyLimit = 6;
